import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getAllSclasses, getClassStudents } from '../../../redux/sclassRelated/sclassHandle';
import { deleteUser } from '../../../redux/userRelated/userHandle';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { BlackButton, BlueButton, GreenButton } from '../../../components/buttonStyles';
import TableTemplate from '../../../components/TableTemplate';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { useToast } from '../../../context/ToastContext';
import ParentChooser from '../../../components/ParentChooser';
import Button from '@mui/material/Button';
 import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'; 
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {  Paper, Box, IconButton, Grid, Card, Typography, Chip, Breadcrumbs, Link, CircularProgress,  Snackbar, Alert, Divider, Menu
} from '@mui/material';
import styled, { keyframes } from 'styled-components';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import LinkIcon from '@mui/icons-material/Link';
import BadgeIcon from '@mui/icons-material/Badge';
import GroupIcon from '@mui/icons-material/Group';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
 import RefreshIcon from '@mui/icons-material/Refresh';

import * as XLSX from 'xlsx';
import { exportToExcel, getCurrentDateString } from '../../../utils/excelExport';
import axios from 'axios';

// Animation keyframes
const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
`;

const cardFloat = keyframes`
    0% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
    100% { transform: translateY(0px); }
`;

const ShowStudents = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, response, getresponse, sclassesList, sclassStudents } = useSelector((state) => state.sclass);
    const { currentUser } = useSelector(state => state.user);
    const { status } = useSelector((state) => state.user);

    // Use sclassStudents for the student list
    const studentsList = sclassStudents;

    console.log("StudentList:", studentsList)
    console.log('Redux state sclassStudents:', sclassStudents);
    console.log('Using studentsList:', studentsList);

    const [viewMode, setViewMode] = useState(() => sessionStorage.getItem('studentsViewMode') || 'classes');
    const [selectedClass, setSelectedClass] = useState(() => {
        const saved = sessionStorage.getItem('studentsSelectedClass');
        return saved ? JSON.parse(saved) : null;
    });
    const { showToast } = useToast();

    // Persist viewMode and selectedClass to sessionStorage
    useEffect(() => {
        sessionStorage.setItem('studentsViewMode', viewMode);
        if (selectedClass) {
            sessionStorage.setItem('studentsSelectedClass', JSON.stringify(selectedClass));
        } else {
            sessionStorage.removeItem('studentsSelectedClass');
        }
    }, [viewMode, selectedClass]);

    // Parent linking state
    const [linkParentOpen, setLinkParentOpen] = useState(false);
    const [selectedStudentForLink, setSelectedStudentForLink] = useState(null);
    const [selectedParent, setSelectedParent] = useState(null);
    const [linkingInProgress, setLinkingInProgress] = useState(false);
    const [importing, setImporting] = useState(false);
    const [importResult, setImportResult] = useState(null);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (viewMode === 'classes') {
            dispatch(getAllSclasses(currentUser._id, "Sclass"));
        } else if (viewMode === 'students' && selectedClass) {
            dispatch(getClassStudents(selectedClass._id));
        }
    }, [currentUser._id, dispatch, viewMode, selectedClass?._id]);

    // Refresh when a new student is added (handled by the effect above on mount, but we keep this for status changes if needed)
    useEffect(() => {
        if (status === 'added' && selectedClass) {
            dispatch(getClassStudents(selectedClass._id));
        }
    }, [status, selectedClass, dispatch]);

    if (error) {
        console.log(error);
    }

    const handleClassClick = (classData) => {
        setSelectedClass(classData);
        setViewMode('students');
        dispatch(getClassStudents(classData._id));
    };

    const handleBack = () => {
        if (viewMode === 'students') {
            setViewMode('classes');
            setSelectedClass(null);
        } else if (viewMode === 'details') {
            setViewMode('students');
        }
    };

    const handleStudentClick = (studentId) => {
        navigate(`/Admin/students/student/${studentId}`);
    };

    const deleteHandler = (deleteID, address) => {
        dispatch({ type: 'student/getDeleteSuccess', payload: null });
        dispatch(deleteUser(deleteID, address))
            .then(() => {
                dispatch({ type: 'student/getSuccess', payload: [] });
                if (selectedClass) {
                    dispatch(getClassStudents(selectedClass._id));
                }
                showToast("Student deleted successfully", "success");
            });
    };

    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const parseImportDate = (value) => {
        if (value === null || value === undefined || value === '') return '';
        const date = value instanceof Date ? value : new Date(value);
        return isNaN(date.getTime()) ? '' : date.toISOString();
    };

    const readFileAsArrayBuffer = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });

    const submitImportedStudents = async (students) => {
        if (!selectedClass) {
            showToast('Please select a class before importing students.', 'warning');
            return;
        }

        try {
            const payload = {
                adminID: currentUser._id,
                sclassName: selectedClass._id,
                students
            };

            const result = await axios.post(`${process.env.REACT_APP_BASE_URL}/Students/BulkCreate`, payload, {
                headers: { 'Content-Type': 'application/json' },
            });

            if (result.data.message) {
                showToast(result.data.message, 'success');
            }

            if (Array.isArray(result.data.errors) && result.data.errors.length > 0) {
                setImportResult(result.data);
                setImportDialogOpen(true);
            }

            dispatch(getClassStudents(selectedClass._id));
        } catch (error) {
            console.error('Bulk import failed:', error);
            showToast(error.response?.data?.message || error.message || 'Student import failed', 'error');
        }
    };

    const handleStudentImportFile = async (event) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        setImporting(true);
        try {
            const rawData = await readFileAsArrayBuffer(file);
            const workbook = XLSX.read(rawData, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            if (!sheetName) {
                throw new Error('No worksheet found in the import file.');
            }

            const worksheet = workbook.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

            if (!Array.isArray(rows) || rows.length === 0) {
                throw new Error('No student rows found in the import file.');
            }

            const students = rows.map((row) => ({
                name: row['Name'] ? String(row['Name']).trim() : '',
                rollNum: row['Roll No'] !== undefined && row['Roll No'] !== null && row['Roll No'] !== '' ? Number(row['Roll No']) : null,
                password: row['Password'] ? String(row['Password']) : '',
                email: row['Email'] ? String(row['Email']).trim() : '',
                phone: row['Phone'] ? String(row['Phone']).trim() : '',
                address: row['Address'] ? String(row['Address']).trim() : '',
                dob: parseImportDate(row['DOB']),
                parent: row['Parent ID'] ? String(row['Parent ID']).trim() : undefined,
                photo: row['Photo URL'] ? String(row['Photo URL']).trim() : '',
                role: row['Role'] ? String(row['Role']).trim() : 'Student',
                totalDays: row['Total Days'] !== undefined && row['Total Days'] !== null && row['Total Days'] !== '' ? Number(row['Total Days']) : undefined,
                presentDays: row['Present Days'] !== undefined && row['Present Days'] !== null && row['Present Days'] !== '' ? Number(row['Present Days']) : undefined,
            }));

            await submitImportedStudents(students);
        } catch (err) {
            console.error('Import error:', err);
            showToast(err.message || 'Unable to parse import file.', 'error');
        } finally {
            resetFileInput();
            setImporting(false);
        }
    };

    const handleDownloadImportTemplate = () => {
        const templateRows = [
            {
                'Name': '  Student name',
                'Roll No': 1,
                'Password': 'Password123!',
                'Email': 'student@example.com',
                'Phone': '9876543210',
                'Address': '123 Example Street',
                'DOB': '2065-04-23'
            }
        ];
        exportToExcel(templateRows, 'Student_Import_Template', 'Template');
    };

    const handleImportClick = () => {
        if (!selectedClass) {
            showToast('Please choose a class before importing students.', 'warning');
            return;
        }
        fileInputRef.current?.click();
    };

    // Student columns - only show fields that exist in the schema
    const studentColumns = [
        { id: 'photo', label: 'Photo', minWidth: 80 },
        { id: 'name', label: 'Name', minWidth: 170 },
        { id: 'rollNum', label: 'Roll No.', minWidth: 80 },
        { id: 'email', label: 'Email', minWidth: 150 },
        { id: 'phone', label: 'Phone', minWidth: 120 },
        { id: 'address', label: 'Address', minWidth: 170 },
    ];


    const studentRows = studentsList && studentsList.length > 0 && studentsList.map((student) => ({
        photo: student.photo,
        name: student.name,
        rollNum: student.rollNum,
        email: student.email || 'N/A',
        phone: student.phone || 'N/A',
        address: student.address || 'N/A',
        id: student._id,
    }));


    const StudentButtonHaver = ({ row }) => {
        return (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <IconButton onClick={() => navigate(`/Admin/students/edit/${row.id}`)} title="Edit Student" sx={{ bgcolor: '#fff3e0', '&:hover': { bgcolor: '#ffe0b2' } }} size="small">
                    <EditIcon color="warning" fontSize="small" />
                </IconButton>

                <IconButton onClick={() => handleStudentClick(row.id)} title="View Student" sx={{ bgcolor: '#e3f2fd', '&:hover': { bgcolor: '#bbdefb' } }} size="small">
                    <VisibilityIcon color="primary" fontSize="small" />
                </IconButton>

                <IconButton onClick={() => deleteHandler(row.id, "Student")} title="Delete Student" sx={{ bgcolor: '#ffebee', '&:hover': { bgcolor: '#ffcdd2' } }} size="small">
                    <PersonRemoveIcon color="error" fontSize="small" />
                </IconButton>
            </Box>
        );
    };

    const actions = [
        {
            icon: <PersonAddAlt1Icon color="primary" />,
            name: 'Add New Student',
            action: () => navigate("/Admin/addstudents")
        },
         
        {
            icon: <PersonRemoveIcon color="error" />,
            name: 'Delete All Students',
            action: () => deleteHandler(currentUser._id, "Students")
        },
    ];

    // Helper function to safely get parent name (father first, then mother, then guardian)
    const getParentName = (p) => {
        if (!p) return '';
        if (p.fatherName && p.fatherName.trim()) return p.fatherName;
        if (p.motherName && p.motherName.trim()) return p.motherName;
        if (p.guardianName && p.guardianName.trim()) return p.guardianName;
        return '';
    };

    // Helper function to safely get parent email
    const getParentEmail = (p) => {
        if (!p) return '';
        if (p.fatherEmail && p.fatherEmail.trim()) return p.fatherEmail;
        if (p.motherEmail && p.motherEmail.trim()) return p.motherEmail;
        if (p.guardianEmail && p.guardianEmail.trim()) return p.guardianEmail;
        return '';
    };

    // Helper function to safely get parent ID
    const getParentID = (p) => {
        if (!p) return '';
        if (p._id) return String(p._id);
        return '';
    };

    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (e) {
            return '';
        }
    };

    // Helper function to safely get field value
    const getFieldValue = (value) => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value.trim() || '';
        if (typeof value === 'number') return value;
        return '';
    };

    // Export students to Excel
    const handleExportStudents = () => {
        if (!studentsList || studentsList.length === 0) {
            showToast('No students to export', 'info');
            return;
        }

        console.log("Exporting students data:", studentsList);

        const exportData = studentsList.map((student) => {
            const parent = student.parent;
            console.log(`Student: ${student.name}, Parent:`, parent);

            return {
                'Photo URL': student.photo ? `${process.env.REACT_APP_BASE_URL}/${student.photo}` : 'No Photo',
                'Student ID': getFieldValue(student._id),
                'Class': student.sclassName?.sclassName || '',
                'Roll No': getFieldValue(student.rollNum),
                'Name': getFieldValue(student.name),

                'Address': getFieldValue(student.address),
                'DOB': formatDate(student.dob),
                'Parent ID': getParentID(parent),
                'Parent Name': getParentName(parent),
                'Parent Gmail': getParentEmail(parent),
                'Father Name': getFieldValue(parent?.fatherName),
                'Father Phone': getFieldValue(parent?.fatherPhone),
                'Mother Name': getFieldValue(parent?.motherName),
                'Mother Phone': getFieldValue(parent?.motherPhone),
                'Guardian Name': getFieldValue(parent?.guardianName),
                'Guardian Phone': getFieldValue(parent?.guardianPhone),
                'Guardian Relation': getFieldValue(parent?.guardianRelation),
            };
        });

        console.log("Export data prepared:", exportData);
        const fileName = `Students_${selectedClass?.sclassName || 'All'}_${getCurrentDateString()}`;
        exportToExcel(exportData, fileName, 'Students');
    };

    // Open parent chooser dialog for linking
    const handleOpenLinkParent = (student) => {
        setSelectedStudentForLink(student);
        setSelectedParent(null);
        setLinkParentOpen(true);
    };

    // Handle parent selection from chooser
    const handleParentSelect = (parent) => {
        setSelectedParent(parent);
    };

    // Link student to parent
    const handleLinkStudentToParent = async () => {
        if (!selectedStudentForLink || !selectedParent) {
            showToast('Please select a parent first', 'error');
            return;
        }

        setLinkingInProgress(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/Parent/Link/${selectedParent._id}/${selectedStudentForLink.id}`
            );

            if (response.data.message) {
                showToast(response.data.message, 'warning');
            } else {
                showToast(`Successfully linked ${selectedStudentForLink.name} to parent`, 'success');

                // Refresh student list
                if (selectedClass) {
                    dispatch(getClassStudents(selectedClass._id));
                }
            }
        } catch (error) {
            console.error("Error linking student to parent:", error);
            showToast(error.response?.data?.message || 'Failed to link student to parent', 'error');
        } finally {
            setLinkingInProgress(false);
            setLinkParentOpen(false);
            setSelectedStudentForLink(null);
            setSelectedParent(null);
        }
    };


    // Render classes as cards
    const renderClassesView = () => (
        <ViewContainer>
            <HeaderSection>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton onClick={() => navigate("/Admin/dashboard")} sx={{ bgcolor: 'white', boxShadow: 1 }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <HeaderLeft>
                        <HeaderTitle>👨‍🎓 Select a Class to View Students</HeaderTitle>
                        <HeaderSubtitle>Choose a class to manage its students</HeaderSubtitle>
                    </HeaderLeft>
                </Box>
            </HeaderSection>

            {loading ? (
                <LoadingWrapper>
                    <CircularProgress size={60} thickness={4} />
                    <Typography sx={{ mt: 2, fontWeight: 500 }}>Loading classes...</Typography>
                </LoadingWrapper>
            ) : (getresponse || response) ? (
                <EmptyState>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>No Classes Found</Typography>
                    <Typography color="textSecondary" sx={{ mb: 3 }}>
                        Get started by adding your first class
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={() => navigate("/Admin/addclass")}
                        sx={{ borderRadius: '10px', px: 4 }}
                    >
                        Add Class
                    </Button>
                </EmptyState>
            ) : (
                <Grid container spacing={3}>
                    {Array.isArray(sclassesList) && sclassesList.map((cls) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={cls._id}>
                            <ClassCard onClick={() => handleClassClick(cls)}>
                                <CardIconWrapper>
                                    <GroupIcon sx={{ fontSize: 40 }} />
                                </CardIconWrapper>
                                <CardTitle>Class {cls.sclassName}</CardTitle>
                                <CardSubtitle>View all students</CardSubtitle>
                                <ViewChip label="View Students" icon={<ArrowForwardIcon />} />
                                <ArrowHint>→</ArrowHint>
                            </ClassCard>
                        </Grid>
                    ))}
                </Grid>
            )}
        </ViewContainer>
    );

    // Render students for selected class
    const renderStudentsView = () => (
        <ViewContainer>
            <HeaderSection>
                <Box>
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a1a2e', mb: 1 }}>
                        Students - Class {selectedClass?.sclassName} 👨‍🎓
                    </Typography>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link
                            color="inherit"
                            href="#"
                            onClick={(e) => { e.preventDefault(); handleBack(); }}
                            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                        >
                            <ArrowBackIcon sx={{ mr: 0.5, fontSize: '1.2rem' }} /> Classes
                        </Link>
                        <Typography color="text.primary">Students</Typography>
                    </Breadcrumbs>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        onClick={() => dispatch(getClassStudents(selectedClass._id))}
                        sx={{ borderRadius: '10px' }}
                    >
                        Refresh
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<AddCircleIcon />}
                        onClick={() => navigate(`/Admin/class/addstudents/${selectedClass._id}`)}
                        sx={{
                            borderRadius: '12px',
                            px: 3,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                            '&:hover': {
                                boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)',
                            }
                        }}
                    >
                        Add Student
                    </Button>
                </Box>
            </HeaderSection>

            <ActionsBar elevation={1}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        startIcon={<UploadFileIcon />}
                        onClick={handleImportClick}
                        disabled={importing}
                        size="small"
                    >
                        Import
                    </Button>
                    <Button
                        startIcon={<FileDownloadIcon />}
                        onClick={handleDownloadImportTemplate}
                        size="small"
                    >
                        Template
                    </Button>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <Button
                        startIcon={<FileDownloadIcon />}
                        onClick={handleExportStudents}
                        disabled={!studentsList || studentsList.length === 0}
                        size="small"
                    >
                        Export All
                    </Button>
                </Box>
                <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleStudentImportFile}
                />
            </ActionsBar>

            {loading ? (
                <LoadingWrapper>
                    <CircularProgress size={60} thickness={4} />
                    <Typography sx={{ mt: 2, fontWeight: 500 }}>Fetching students...</Typography>
                </LoadingWrapper>
            ) : (getresponse || response) ? (
                <EmptyState>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>No Students Found</Typography>
                    <Typography color="textSecondary" sx={{ mb: 3 }}>
                        Add students manually or import them from an Excel file.
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate(`/Admin/class/addstudents/${selectedClass._id}`)}
                        sx={{ borderRadius: '10px', px: 4 }}
                    >
                        Add Your First Student
                    </Button>
                </EmptyState>
            ) : (
                <TablePaper>
                    {Array.isArray(studentsList) && studentsList.length > 0 && (
                        <TableTemplate buttonHaver={StudentButtonHaver} columns={studentColumns} rows={studentRows} />
                    )}
                </TablePaper>
            )}
        </ViewContainer>
    );

    return (
        <PageContainer>
            <MainContainer maxWidth="xl">
                {viewMode === 'classes' && renderClassesView()}
                {viewMode === 'students' && renderStudentsView()}

                {/* Parent Chooser Dialog for Linking */}
                <Dialog open={linkParentOpen} onClose={() => setLinkParentOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                        Link Parent to Student
                    </DialogTitle>
                    <DialogContent sx={{ mt: 2 }}>
                        {selectedStudentForLink && (
                            <Alert severity="info" sx={{ mb: 2 }}>
                                Linking parent for student: <strong>{selectedStudentForLink.name}</strong> (Roll No: {selectedStudentForLink.rollNum})
                            </Alert>
                        )}
                        <ParentChooser
                            open={linkParentOpen}
                            onClose={() => setLinkParentOpen(false)}
                            onSelect={handleParentSelect}
                            onCreateNew={() => {
                                navigate("/Admin/addparent");
                                setLinkParentOpen(false);
                            }}
                            schoolId={currentUser._id}
                            title="Select Parent / Guardian"
                            buttonText="Select Parent"
                            selectedParent={selectedParent}
                            showCreateNew={true}
                        />
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={() => setLinkParentOpen(false)} color="inherit">
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleLinkStudentToParent}
                            disabled={!selectedParent || linkingInProgress}
                            startIcon={linkingInProgress ? <CircularProgress size={20} color="inherit" /> : <LinkIcon />}
                        >
                            {linkingInProgress ? 'Linking...' : 'Link Parent'}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={importDialogOpen} onClose={() => setImportDialogOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                        Import Results
                    </DialogTitle>
                    <DialogContent sx={{ mt: 2 }}>
                        {importResult?.createdCount >= 0 && (
                            <Alert severity="success" sx={{ mb: 2 }}>
                                {importResult.createdCount} student(s) imported successfully.
                            </Alert>
                        )}
                        {importResult?.errorCount > 0 ? (
                            <>
                                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                    {importResult.errorCount} row(s) failed validation:
                                </Typography>
                                {importResult.errors.map((errorItem, index) => (
                                    <Box key={index} sx={{ mb: 1, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            Row {errorItem.row}
                                        </Typography>
                                        <ul style={{ margin: '8px 0 0 16px', padding: 0 }}>
                                            {errorItem.errors.map((errMsg, errIndex) => (
                                                <li key={errIndex} style={{ fontSize: '0.95rem', lineHeight: 1.5 }}>
                                                    {errMsg}
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                ))}
                            </>
                        ) : (
                            <Typography>No import errors were reported.</Typography>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={() => setImportDialogOpen(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

            </MainContainer>
        </PageContainer>
    );
};

// Styled Components - DEPENDENT COMPONENTS FIRST
// Components that are referenced by other components' hover styles MUST be defined before those components
const CardIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    border-radius: 18px;
    background: #f0f4ff;
    color: #667eea;
    margin-bottom: 16px;
    transition: all 0.3s ease;
    
    & svg {
        font-size: 36px;
    }
`;

const ArrowHint = styled.span`
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%) translateX(-10px);
    opacity: 0;
    font-size: 1.5rem;
    color: #667eea;
    transition: all 0.3s ease;
`;

const PageContainer = styled.div`
    min-height: 100vh;
    background: #f0f2f5;
    padding: 24px;
`;

const MainContainer = styled.div`
    animation: ${fadeIn} 0.4s ease-out;
`;

const ViewContainer = styled.div`
    animation: ${fadeIn} 0.4s ease-out;
`;

const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    flex-wrap: wrap;
    gap: 16px;
    
    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const HeaderLeft = styled.div`
    display: flex;
    flex-direction: column;
`;

const HeaderTitle = styled.h1`
    font-size: 1.5rem;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0 0 4px 0;
`;

const HeaderSubtitle = styled.p`
    font-size: 0.9rem;
    color: #888;
    margin: 0;
`;

const HeaderHelp = styled.p`
    font-size: 0.85rem;
    color: #555;
    margin: 8px 0 0;
    max-width: 640px;
    line-height: 1.5;
`;

const AddButton = styled(Button)`
    border-radius: 12px !important;
    padding: 10px 20px !important;
    font-weight: 600 !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3) !important;
    
    &:hover {
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
        transform: translateY(-2px);
    }
`;

const ExportButton = styled(Button)`
    border-radius: 12px !important;
    padding: 10px 20px !important;
    font-weight: 600 !important;
    border-color: #667eea !important;
    color: #667eea !important;
    
    &:hover {
        background: #f0f4ff !important;
        border-color: #667eea !important;
    }
`;

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    color: #667eea;
`;

const LoadingText = styled.p`
    margin-top: 16px;
    font-size: 1rem;
    color: #888;
`;

const EmptyStateContainer = styled.div`
    text-align: center;
    padding: 60px 20px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

const EmptyStateIcon = styled.div`
    font-size: 4rem;
    margin-bottom: 16px;
`;

const EmptyStateTitle = styled.h3`
    font-size: 1.3rem;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0 0 8px 0;
`;

const EmptyStateText = styled.p`
    font-size: 0.95rem;
    color: #888;
    margin: 0;
`;

const ClassCard = styled(Card)`
    cursor: pointer;
    border-radius: 16px !important;
    background: #ffffff !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    padding: 24px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 100%;
    
    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
        
        ${CardIconWrapper} {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #ffffff;
            animation: ${cardFloat} 2s ease-in-out infinite;
        }
        
        ${ArrowHint} {
            opacity: 1;
            transform: translateY(-50%) translateX(0);
        }
    }
`;

const CardTitle = styled(Typography)`
    font-size: 1.2rem;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 8px;
`;

const CardSubtitle = styled(Typography)`
    font-size: 0.85rem;
    color: #888;
`;

const ViewChip = styled(Chip)`
    margin-top: 16px !important;
    border-radius: 20px !important;
    background: #f0f4ff !important;
    color: #667eea !important;
    font-weight: 500 !important;
    
    .MuiChip-icon {
        color: #667eea;
    }
`;

const BreadcrumbsStyled = styled(Breadcrumbs)`
    margin-bottom: 24px;
`;

const BreadcrumbLink = styled(Link)`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #667eea !important;
    font-weight: 500;
    
    &:hover {
        text-decoration: underline;
    }
`;

const BreadcrumbCurrent = styled(Typography)`
    color: #1a1a2e !important;
    font-weight: 500;
`;

const TablePaper = styled(Paper)`
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
`;

const ActionsBar = styled(Paper)`
  padding: 12px 20px;
  border-radius: 12px !important;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border: 1px solid #eee;
`;

const LoadingWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #667eea;
`;

const EmptyState = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  border-radius: 20px;
  text-align: center;
  background: white;
  border: 1px dashed #ccc;
`;

export default ShowStudents;

